import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './flyer-container-empty-design.scss'
import cn from 'classnames'

const CUSTOM_FLYER_DESIGN_NUMBER = '8'
const CUSTOM_FLYER_DESIGN_SLUG = 'hobnob:custom'

class FlyerContainerEmptyDesign extends Component {
  state = {
    backGroundImageRef: null
  }

  backGroundImageElement = new Image()
  backGroundImageRef = null

  detectImageInViewByRef = ref => {
    if (!ref) return
    this.backGroundImgIntersectionObserver.observe(ref)
  }

  componentDidMount() {
    this.props.onRef?.(this)
  }

  renderBackgroundImage = () => {
    const { customBgDataURL } = this.props
    if (customBgDataURL) {
      this.backGroundImageElement.src = customBgDataURL
    }

    return (
      <img
        className={styles['image-inner']}
        src={this.backGroundImageElement.src}
        ref={ref => {
          if (!this.state.backGroundImageRef) {
            this.backGroundImageRef = ref
            this.setState({ backGroundImageRef: ref })
          }
        }}
        alt={`can't see image? try to refresh the page.`}
      />
    )
  }

  canvasToImage = () => {
    const { onChangeEventForm } = this.props
    const canvasWidth = this.backGroundImageElement.width
    const canvasHeight = this.backGroundImageElement.height

    const canvasEl = document.createElement('canvas')
    const context = canvasEl.getContext('2d')
    canvasEl.className = styles['canvas']
    canvasEl.width = canvasWidth
    canvasEl.height = canvasHeight

    context.drawImage(this.backGroundImageElement, 0, 0, canvasWidth, canvasHeight)

    const imgFile = canvasEl.toDataURL('image/png')
    onChangeEventForm({
      checkedFlyer: imgFile
    })

    return imgFile
  }

  handleClick = () => {
    const { onChangeEventForm, eventForm, type } = this.props
    if (type === 'edit') {
      return
    }

    if (eventForm.flyer_design_number === CUSTOM_FLYER_DESIGN_NUMBER) {
      onChangeEventForm({ flyer_design_number: null, flyer_design_slug: null, checkedFlyer: null })
      return
    }
    this.props.onFlyerSelected(this)

    onChangeEventForm({
      flyer_design_number: CUSTOM_FLYER_DESIGN_NUMBER,
      flyer_design_slug: CUSTOM_FLYER_DESIGN_SLUG
    })
  }

  render = () => {
    const { eventForm, type } = this.props

    return (
      <div className={styles['container']}>
        <div
          className={cn(styles['flyer-container'], {
            [styles['flyer-container-checked']]:
              type !== 'edit' && eventForm.flyer_design_number === CUSTOM_FLYER_DESIGN_NUMBER
          })}
          onClick={this.handleClick}
        >
          {this.renderBackgroundImage()}
        </div>
      </div>
    )
  }

  initBackgroundImageElement = () => {
    this.backGroundImageElement.crossOrigin = 'Anonymous'
    this.backGroundImageElement.width = 640
    this.backGroundImageElement.height = 640 * (16 / 9)
    this.backGroundImageElement.className = styles['image-inner']
  }
}

FlyerContainerEmptyDesign.defaultProps = {
  eventForm: {}
}

FlyerContainerEmptyDesign.propTypes = {
  eventForm: PropTypes.object,
  onChangeEventForm: PropTypes.func,
  onFlyerSelected: PropTypes.func,
  onRef: PropTypes.func,
  type: PropTypes.string,
  customBgDataURL: PropTypes.string
}

export default FlyerContainerEmptyDesign
